import styled from 'styled-components';

export const BenefitsWrapper = styled.section`
  padding: 32px 16px;
  background-color: #ffffff;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 20px;
`;

export const BenefitsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BenefitCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px;
  background-color: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 14px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
`;

export const IconBox = styled.div`
  background-color: #f3e8ff;
  color: #8b5cf6;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const BenefitContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BenefitTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
`;

export const BenefitDesc = styled.div`
  font-size: 13px;
  color: #64748b;
  margin: 0;
  line-height: 1.4;
`;
